import { FlexBox } from '@dixa/lib-shared-habla';

import { ArticleSuggestion } from '../../types';
import { ArticleContent } from '../ArticleContent';
import { ArticleStatusBar } from '../ArticleStatusBar';
import { CopyArticleLink } from '../CopyArticleLink';
import { OpenArticleInTab } from '../OpenArticleInTab';

import styles from './ArticleRow.module.scss';

export type ArticleRowProps = {
  /** Elevio article */
  article: ArticleSuggestion;
  /** Used to determine if a row is selected */
  selectedArticleId: string | null;
  /** Select Article Callback */
  onSelectArticle: ({
    articleId,
    articleTitle,
  }: {
    articleId: string;
    articleTitle: string;
  }) => void;
};

export function ArticleRow({
  article,
  onSelectArticle,
}: ArticleRowProps): JSX.Element {
  const {
    title: articleTitle,
    category: { title: categoryTitle },
    tags: articleTags,
    id: articleId,
    accessControl: { isInternal },
  } = article;

  const articleSlug = article.slug || '';

  return (
    <FlexBox
      className={styles.article}
      as="article"
      onClick={() => onSelectArticle({ articleId, articleTitle })}
      maxWidth="100%"
      title={articleTitle}
    >
      <ArticleStatusBar isInternal={isInternal} />
      <ArticleContent
        className={styles.hover}
        articleTitle={articleTitle}
        articleTags={articleTags}
        categoryTitle={categoryTitle}
      />
      <FlexBox gap="300" alignItems="center" justifyContent="center">
        <CopyArticleLink articleSlug={articleSlug} />
        <OpenArticleInTab articleSlug={articleSlug} />
      </FlexBox>
    </FlexBox>
  );
}
